import { render, staticRenderFns } from "./UserContacts.vue?vue&type=template&id=68d29ba8&"
import script from "./UserContacts.vue?vue&type=script&lang=js&"
export * from "./UserContacts.vue?vue&type=script&lang=js&"
import style0 from "./UserContacts.vue?vue&type=style&index=0&id=68d29ba8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports